import React from 'react';
import { MessageSquare, Plus, Trash2, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

function formatRelative(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.floor(hrs / 24);
  if (days < 7) return `${days}d ago`;
  return d.toLocaleDateString();
}

export default function ThreadList({
  threads,
  activeThreadId,
  loading,
  onSelect,
  onDelete,
  onNew,
}) {
  return (
    <div className="flex flex-col h-full bg-white border-r border-slate-200 w-64 flex-shrink-0">
      <div className="p-3 border-b border-slate-200">
        <Button
          onClick={onNew}
          variant="outline"
          size="sm"
          className="w-full justify-start gap-2"
        >
          <Plus className="w-4 h-4" />
          New chat
        </Button>
      </div>

      <div className="flex-1 overflow-y-auto py-2">
        {loading && threads.length === 0 ? (
          <div className="flex items-center justify-center py-6 text-slate-400 text-sm">
            <Loader2 className="w-4 h-4 animate-spin mr-2" />
            Loading…
          </div>
        ) : threads.length === 0 ? (
          <div className="px-3 py-6 text-center text-xs text-slate-400">
            No chats yet. Tell Trace about a trip to start one.
          </div>
        ) : (
          <ul className="space-y-0.5 px-2">
            {threads.map((t) => {
              const active = t.id === activeThreadId;
              return (
                <li key={t.id}>
                  <div
                    className={`group flex items-center gap-2 rounded-md px-2 py-1.5 text-sm cursor-pointer ${
                      active
                        ? 'bg-emerald-50 text-emerald-900'
                        : 'text-slate-700 hover:bg-slate-100'
                    }`}
                    onClick={() => onSelect(t.id)}
                  >
                    <MessageSquare
                      className={`w-4 h-4 flex-shrink-0 ${
                        active ? 'text-emerald-600' : 'text-slate-400'
                      }`}
                    />
                    <div className="flex-1 min-w-0">
                      <div className="truncate font-medium">{t.title || 'New chat'}</div>
                      <div className="text-[10px] text-slate-400">
                        {formatRelative(t.last_message_at)}
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        onDelete(t.id);
                      }}
                      title="Delete chat"
                      className="opacity-0 group-hover:opacity-100 text-slate-400 hover:text-red-600 transition-opacity"
                    >
                      <Trash2 className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}
